


























import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class ContactFormField extends Vue {
  @Prop({type: String, required: true}) name!: string
  @Prop({type: String, required: true}) label!: string
  @Prop({type: Boolean, default: false}) required!: boolean

  /** Validation message to display. Falsy hides the error line. */
  @Prop({type: String, default: null}) error!: string | null

  /** Optional character count, e.g. "120/1000". */
  @Prop({type: String, default: null}) counter!: string | null
}
